import {useAuth} from "../../../context";
import {Navigate} from "react-router-dom";
import {PropsWithChildren} from "react";

export function AdminRoute({ children }: PropsWithChildren) {
    const { isAuthenticated, isAdmin } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (!isAdmin) {
        return <Navigate to="/panel" replace />;
    }

    return <>{children}</>;
}
